export default __webpack_public_path__ + "static/media/annex-contact_2.f2092c73.jpg";